// This value should match the height specified in placeholder-tile.scss
export const kPlaceholderTileDefaultHeight = 50;
